/**
 * SAP CONFIDENTIAL
 *
 * This software is confidential proprietary software licensed by SAP SE
 * and is not to be used, duplicated or disclosed to anyone without the
 * prior written permission of SAP.
 *
 * (C) 2020 Copyright SAP SE.
 */
export class Calendar {
  id!: string;
  name!: string;
  type!: string;
  start!: object;
  startDate: any;
  end!: object;
  endDate: any;
  commissionable: any;
  serviceDay: any;
  serviceMonth: any;
  returnDay: any;
  returnMonth: any;
  deliveryDay: any;
  deliveryMonth: any;
  startYear!: string;
  endYear!: string;
}

export class PlanPeriod {
  id!: string;
  name!: string;
  typeId = 'MONTH';
  startDay!: number;
  endDay!: number;
  startMonth!: number;
  endMonth!: number;
  orderId!: number;
  commissionable: any;
  serviceDay: any;
  serviceMonth: any;
  returnDay: any;
  returnMonth: any;
  deliveryDay: any;
  deliveryMonth: any;
  startYear!: string;
  endYear!: string;
}

export class SavePlanCalendar {
  name!: string;
  typeId = 'YEAR';
  periods!: PlanPeriod[];
  id: any;
  startMonth!: number;
  startDay!: number;
  endMonth!: number;
  endDay!: number;
  commissionable: any;
  serviceDay: any;
  serviceMonth: any;
  returnDay: any;
  returnMonth: any;
  deliveryDay: any;
  deliveryMonth: any;
  orderId: any;
  startTime: any;
  timeZone: any;
  endTime: any;
}
